/**
 * Escapar antes de meter un dato en `innerHTML`.
 *
 * ⚠️ **No es prolijidad: en el registro de actividad entra texto que no escribimos nosotros** —el
 * motivo de una derivación lo redacta el asistente a partir de lo que dijo el contacto del negocio—,
 * y el nombre de un usuario lo teclea el cliente. Mientras esas filas mostraban frases nuestras el
 * `innerHTML` era inofensivo; en cuanto muestran contenido ajeno deja de serlo, y en el panel de
 * admin el contenido es **de otro inquilino**: ahí un `<script>` guardado en un nombre se ejecuta
 * con la sesión de quien administra a todos.
 *
 * La CSP de estos dos sitios permite `unsafe-inline` (el tema se aplica con un `<script>` en línea),
 * así que no hay una segunda barrera detrás de ésta.
 */
export const esc = (v) => String(v ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;');
